import axios from "axios";
import { apiEndpoint } from "../configuration";

import cookiesService from "./CookiesServices";

let axiosConfig = {
  withCredentials: true,
};

class AuthService {
  constructor() {
    const token = cookiesService.get("token");
    this.authenticated = !!token;
  }
  async ValidateUser(data) {
    try {
      const response = await axios.post(
        `${apiEndpoint}/adminusers/verify`,
        data,
        axiosConfig
      );
      console.log("response", response);
      return response.data;
    } catch (error) {
      console.error("error", error);
      return false;
    }
  }

  async UpdateUserToken(token) {
    console.log("In API Token in UpdateUserToken", token);
    try {
      const response = await axios.post(
        `${apiEndpoint}/adminusers/updatetoken`,
        token,
        axiosConfig
      );
      console.log("response", response);
      return response.data;
    } catch (error) {
      console.error("error", error);
      return false;
    }
  }

  isAuthenticated() {
    const token = cookiesService.get("token");
    console.log("isAuthenticated", token);
    this.authenticated = !!token;
    return this.authenticated;
  }
  isAuthorised(roleid) {
    // TODO: Implement authorization logic based on roleid
    return true;
  }
  getUserDetails() {
    let data = cookiesService.get("user");
    console.log("getUserDetails", data);
    if (data) {
      return data;
    } else {
      return [];
    }
  }
  handleLoginSuccess(response, remember) {
    if (!response || !Array.isArray(response) || !response[0]) {
      if (process.env.NODE_ENV === "development") {
        console.error("handleLoginSuccess: invalid response", response);
      }
      return false;
    }
    const user = response[0];
    const token = user && user.token;
    if (!token) {
      if (process.env.NODE_ENV === "development") {
        console.error("handleLoginSuccess: no token in response", user);
      }
      return false;
    }
    const expiryDate = new Date();
    expiryDate.setTime(expiryDate.getTime() + 24 * 60 * 60 * 1000); // 24hrs

    cookiesService.set("token", token, {
      path: "/",
      expires: expiryDate,
    });
    cookiesService.set("user", JSON.stringify(user), {
      path: "/",
      expires: expiryDate,
    });
    return true;
  }
  async logout() {
    try {
      cookiesService.remove("token");
      cookiesService.remove("user");
      cookiesService.remove("data");
      const response = await axios.post(
        `${apiEndpoint}/adminusers/logout`,
        {},
        axiosConfig
      );
      console.log("response", response);
      return response.data;
    } catch (error) {
      console.error("error", error);
      return false;
    }
  }
}
const authService = new AuthService();
export default authService;
